// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nsdt","icon":"styles_icon__3nKhQ"};